/** 空间分类 **/
import Tools from '@/core/tools'
import Utils from '@/core/utils'
const state = {
  classify: [],
  // 空间自定义分类，包含数量——当前用户有权限的
  classifyAgg: [],
  // 空间自定义分类——当前用户有权限的
  classifyAuth: [],
  customCategories: [],
  spacesDetail: [],
}

const getters = {
  spacePlatClassify: (state) => state.classify,
  spacesDetail: (state) => state.spacesDetail,
  spaceClassifyTree: (state) => {
    const arr = Tools.deepCopy(state.classify)
    return Utils.listToTree(arr, false, 'id')
  },
  getRoot: (state) => {
    const node = state.classifyAgg.find((x) => !x.parentId)
    return node || {}
  },
  getOther: (state) => {
    const root = state.classify.find((x) => !x.parentId)
    const node = state.classify.find((x) => x.name === '其他' && x.parentId === root.id)
    return node || {}
  },
  getSpaceClassifyIds: (state, getters) => {
    return (id) => {
      if (id) {
        // 前端需要展示全路径（包含全部）
        const rootNode = getters.getRoot
        const { ids } = Utils.getPathByChild(state.classify, id, rootNode.parentId || null)
        return ids
      }
      return []
    }
  },
  getTreeAuthWithCount: (state) => {
    const classify = state.classify || []
    const catalog = classify.map((item) => {
      return {
        ...item,
        count: state.classifyAgg.find((it) => it.id === item.id)?.count
      }
    })
    const arr = Tools.deepCopy(catalog)
    return Utils.classifyAuthListToTree(arr)
  },
}

const mutations = {
  SET_PLAT_CLASSIFY(state, data) {
    state.classify = data
  },
  SET_PLAT_CLASSIFY_AGG(state, data) {
    state.classifyAgg = data
  },
  SET_PLAT_CLASSIFY_AUTH(state, data) {
    state.classifyAuth = data
  },
  SET_Custom_Categories(state, data) {
    state.customCategories = data
  },
  SET_Spaces_Detail(state, data) {
    state.spacesDetail = data
  },
}

const actions = {
  // 获取当前用户有权限的目录列表
  async getSpacePlatClassify({ commit }, filter) {
    try {
      const data = await this.$api.resource.getSpacePlatClassify(filter)
      commit('SET_PLAT_CLASSIFY', data || [])
    } catch (err) {
      commit('SET_PLAT_CLASSIFY', [])
    }
  },
  // 获取获取聚合目录
  async getSpacePlatClassifyAgg({ commit }, query) {
    try {
      const res = await this.$api.resource.getSpaceClassifiesAgg(query)
      commit('SET_PLAT_CLASSIFY_AGG', res || [])
    } catch (err) {
      commit('SET_PLAT_CLASSIFY_AGG', [])
    }
  },
  // 获取空间自定义分类的平铺列表-当前用户有权限的
  async getPlatClassifyAuth({ commit }, query) {
    try {
      const res = await this.$api.resource.classify.getSpacePlatClassifyAuth(query)
      commit('SET_PLAT_CLASSIFY_AUTH', res || [])
    } catch (err) {
      commit('SET_PLAT_CLASSIFY_AUTH', [])
    }
  },
  // 空间自定义分类创建
  async customCategories({ commit }, query) {
    try {
      const res = await this.$api.resource.customCategories(query)
      commit('SET_Custom_Categories', res || [])
    } catch (err) {
      commit('SET_Custom_Categories', [])
    }
  },
  // 获取空间信息
  async getSpacesDetail({ commit }, query) {
    try {
      const res = await this.$api.space.getSpacesDetail(query)
      commit('SET_Spaces_Detail', res || {})
      sessionStorage.setItem('spaceName', res.name)
    } catch (err) {
      commit('SET_Spaces_Detail', {})
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
